export default `
  fragment ParagraphAnchor on ParagraphAnchor {
    id
    uuid
    entityBundle
    anchor
  }
`
